var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Base } from '@or-sdk/base';
import { SERVICE_KEY } from './constants';
export class Notifications extends Base {
    constructor(params) {
        const { token, discoveryUrl, accountId, notificationsUrl } = params;
        super({
            token,
            discoveryUrl,
            serviceKey: SERVICE_KEY,
            accountId,
            serviceUrl: notificationsUrl,
        });
    }
    listNotifications(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: '/user',
                method: 'GET',
                params,
            });
        });
    }
    markSeen() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: '/user',
                method: 'POST',
            });
        });
    }
    createUserNotification(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: '/user',
                method: 'PUT',
                data,
            });
        });
    }
    SACreateNotification(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: '/service',
                method: 'PUT',
                data,
            });
        });
    }
    SAListNotifications(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: '/service',
                method: 'GET',
                params,
            });
        });
    }
    SAUpdateNotification(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: `/service/${id}`,
                method: 'POST',
                data,
            });
        });
    }
    SADeleteNotification(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: `/service/${id}`,
                method: 'DELETE',
            });
        });
    }
    createTrailEvent(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: `/trail/${data.service}`,
                method: 'PUT',
                data: data.data,
            });
        });
    }
    listTrailEvents(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: '/trail',
                method: 'GET',
                params,
            });
        });
    }
}
//# sourceMappingURL=Notifications.js.map